import { useLocation, useNavigate } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const SCREEN_BY_PATH = { "/": "dashboard", "/loads": "loads", "/cruces": "cruces", "/cajas": "cajas" };

// Botón flotante de ayuda (Parte A) — visible siempre abajo a la derecha en todas las pantallas.
export function HelpMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const screenKey = SCREEN_BY_PATH[location.pathname];

  const relaunch = () => {
    if (screenKey) window.dispatchEvent(new CustomEvent("trebol:launch-tour", { detail: { screen: screenKey } }));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="help-button"
          data-tour="help-button"
          className="fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform hover:scale-105"
        >
          <HelpCircle className="h-6 w-6" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {screenKey && (
          <DropdownMenuItem data-testid="help-menu-tour" onClick={relaunch}>
            Ver tutorial de esta pantalla
          </DropdownMenuItem>
        )}
        <DropdownMenuItem data-testid="help-menu-guias" onClick={() => navigate("/guias")}>
          Abrir guías
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
